import React, { useState, useEffect, useCallback } from "react";
import { phoneWhatsapp } from "../../shared/config/phone";

// --- DADOS FICTÍCIOS PARA O CARROSSEL ---
const CAROUSEL_DATA = [
  {
    id: 1,
    title: "Cuidado profissional dentro da sua casa",
    text: "Levamos atendimento de Home Care com profissionais qualificados, garantindo conforto, segurança e cuidado personalizado no ambiente do seu lar.",
    buttonText: "Clique aqui e leia mais sobre",
    action: "Olá, gostaria de saber mais sobre Home Care"
  },
  {
    id: 2,
    title: "Atendimento rápido e fácil por WhatsApp",
    text: "Fale conosco pelo WhatsApp e receba um atendimento prático, rápido e seguro, no horário que for melhor para você.",
    buttonText: "Agende sua visita agora",
    action: "Olá, gostaria de saber mais sobre Home Care"
  },
  {
    id: 3,
    title: "Equipe especializada e com experiência",
    text: "Contamos com profissionais capacitados e experientes para oferecer atendimento de home care com segurança, cuidado e qualidade.",
    buttonText: "Conheça nossos profissionais",
    action: "Olá, gostaria de saber mais sobre Home Care"
  },
];

// Ícone de Seta para o Botão
const ArrowIcon = () => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 54 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="53.605" height="53.605" rx="26.8025" fill="white" />
    <path
      d="M20.8025 14.8027H38.8025V32.8027"
      stroke="black"
      strokeWidth="4"
      strokeMiterlimit="10"
    />
    <path
      d="M38.8025 14.8027L14.8025 38.8027"
      stroke="black"
      strokeWidth="4"
      strokeMiterlimit="10"
    />
  </svg>
);

const HeroCardContent = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const totalSlides = CAROUSEL_DATA.length;
  const currentSlide = CAROUSEL_DATA[currentIndex];

  const nextSlide = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % totalSlides);
  }, [totalSlides]);

  useEffect(() => {
    const interval = setInterval(nextSlide, 8000);
    return () => clearInterval(interval);
  }, [nextSlide]);

  const goToSlide = (slideIndex) => setCurrentIndex(slideIndex);

  const cardClasses = `
    absolute bottom-3 left-1/2 -translate-x-1/2 
    md:left-[95px] md:translate-x-0 
    w-[90%] sm:w-[95%] md:w-[480px] lg:w-[900px]
    px-6 sm:px-10 md:px-[80px] 
    py-6 sm:py-8 md:py-10 
    bg-white/80 backdrop-blur-md rounded-[25px] md:rounded-[35px]
    shadow-2xl transition-all duration-300 overflow-hidden z-20
  `;

  return (
    <div className={cardClasses}>
      {/* Conteúdo do slide */}
      <div key={currentSlide.id} className="transition-opacity duration-500">
        <p className="text-xl sm:text-2xl md:text-3xl font-bold text-[#00394F] mb-3 sm:mb-4">
          {currentSlide.title}
        </p>

        <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-6 sm:mb-8 line-clamp-4 sm:line-clamp-none">
          {currentSlide.text}
        </p>
      </div>

      {/* Rodapé do card */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 sm:gap-0">
        {/* Indicadores do carrossel */}
        <div className="flex space-x-2 sm:space-x-3">
          {CAROUSEL_DATA.map((_, index) => (
            <div
              key={index}
              className={`w-4 h-4 sm:w-5 sm:h-5 border-[3px] sm:border-[4px] border-white rounded-full cursor-pointer transition-colors duration-300 ${index === currentIndex
                ? "bg-[#00394F]"
                : "bg-gray-300 opacity-80"
                }`}
              onClick={() => goToSlide(index)}
            ></div>
          ))}
        </div>

        {/* Botão */}
        <a className="w-full sm:w-auto inline-flex items-center justify-center rounded-full bg-black 
        py-2 px-5 sm:pl-6 sm:pr-2 text-sm sm:text-base font-medium text-white shadow-xl transition-colors 
        hover:bg-gray-800" href={`https://wa.me/${phoneWhatsapp}?text=${encodeURIComponent(`Olá, tudo bem? Eu estava na página "Home Care - Bianco Azure" e gostaria de conversar com vocês.`)}`}>
          <p className="pr-3 text-center sm:text-left">
            {currentSlide.buttonText}
          </p>
          <ArrowIcon />
        </a>
      </div>
    </div>
  );
};

export default HeroCardContent;
